/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import SendAssetForm from './SendAssetForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(SendAssetForm);